import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";
import Resumo from "./Resumo/Resumo";
import KpisEstruturais from "./KpisEstruturais/KpisEstruturais";
import KpisPerformance from "./KpisPerformance/KpisPerformance";
import VendaExcelente from "./VendaExcelente/VendaExcelente";
import Ranking from "./Ranking/Ranking";
import Alertas from "./Alertas/Alertas";
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";
import Faq from "./Faq";
import { RegrasCampanhas } from "./RegrasCamapnha";

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <LeftSideMenu app={app} config={config} />
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <Switch>
          <Route exact path="/">
            <Redirect to="/resumo" />
          </Route>

          <Route
            path="/resumo"
            exact
            render={() => <Resumo app={app} config={config} />}
          />

          <Route
            path="/estruturais"
            exact
            render={() => <KpisEstruturais app={app} config={config} />}
          />

          <Route
            path="/performance"
            exact
            render={() => <KpisPerformance app={app} config={config} />}
          />

          <Route
            path="/excelente"
            exact
            render={() => <VendaExcelente app={app} config={config} />}
          />

          <Route
            path="/ranking"
            exact
            render={() => <Ranking app={app} config={config} />}
          />

          <Route
            path="/alertas"
            exact
            render={() => <Alertas app={app} config={config} />}
          />

          <Route
            path="/faq"
            exact
            render={() => <Faq app={app} config={config} />}
          />

          <Route path="/regras" exact render={() => <RegrasCampanhas />} />
        </Switch>
      </HashRouter>
    </div>
  );
}

export default Layout;
